import { useNavigate } from "@tanstack/react-router"
import { useState } from "react"

import { ProjectSettingsDialog } from "@/components/ProjectSettingsDialog/ProjectSettingsDialog.tsx"
import { Page } from "@/routes/auth/Page.tsx"
import { Navigator } from "@/routes/Navigator.ts"
import { useCurrentOrgId, useCurrentProject } from "@/routes/projects/projectHooks.ts"

export const ProjectSettingsDialogOpener = () => {
  const orgId = useCurrentOrgId()
  const project = useCurrentProject()
  const navigate = useNavigate()

  const [dialogOpen, setDialogOpen] = useState(true)

  const handleDialogClose = (open: boolean) => {
    setDialogOpen(open)
    if (!open) {
      void navigate(Navigator.project(orgId, project.key))
    }
  }

  return (
    <Page>
      <ProjectSettingsDialog project={project} dialogOpen={dialogOpen} setDialogOpen={handleDialogClose} />
    </Page>
  )
}
